import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';


@Injectable()
export class AdmEligibilityMessagesServiceService {

  constructor(private _httpClient: IesHttpClient) {
  }

  getFailedMessages() {
    return this._httpClient.get(AppUrl.getEligibilityMessageCount, '');
  }

  pushMessages() {
    return this._httpClient.post(AppUrl.pushEligibilityMessages, '');
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-eligibility-messages/adm-eligibility-messages-service.service.ts